// card-format.ts — pure formatting helpers for result-card rendering.
// Kept Lit-free (no component registration) so it's unit-testable the same
// way as quick-chips-helper.

import type { ResultCard } from '../types/search.js';

/**
 * K8s node-count label for a result card.
 *   - worker mode → the STATIC node Quantity (e.g. "3 nodes", "1 node").
 *   - asg / both  → the autoscale range, collapsed to "N nodes" when
 *     min === max so we never render a degenerate "1–1 nodes".
 */
export function k8sNodeCountLabel(card: ResultCard): string {
  if (card.k8sMode === 'worker') {
    const n = card.k8sWorkerCount ?? card.nodeMin ?? 1;
    return `${n} ${n === 1 ? 'node' : 'nodes'}`;
  }
  const lo = card.nodeMin ?? 0;
  const hi = card.nodeMax ?? 0;
  if (lo === hi) return `${lo} ${lo === 1 ? 'node' : 'nodes'}`;
  return `${lo}–${hi} nodes`;
}
